import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleErrors } from "../../util/helpers/ErrorHelper";
import { DateTimeNow, DateTimeNowSimple } from "../../util/DateTranslater";
import Storage from "../../util/Storage";
import { CurrencyConverter } from "../../util/helpers/MoneyHelper";

export const FedexController = {
    BaseModel: {
        accountNumber: {
            value: "201965867"
        },
        rateRequestControlParameters: {
            returnTransitTimes: true
        },
        requestedShipment: {
            shipper: {
                address: {
                    streetLines: [
                        "Rua Farroupilha, 8"
                    ],
                    city: "Vargem Grande Paulista",
                    stateOrProvinceCode: "SP",
                    postalCode: "06730000",
                    countryCode: "BR",
                    residential: true
                }
            },
            recipient: {
                address: {
                    streetLines: [
                        "1501 Hammond Dr, 3435"
                    ],
                    city: "Miami Springs",
                    stateOrProvinceCode: "FL",
                    postalCode: "33166",
                    countryCode: "US",
                    residential: true
                }
            },
            serviceType: "FEDEX_INTERNATIONAL_PRIORITY_EXPRESS",
            shipDateStamp: "2024-03-02",
            pickupType: "DROPOFF_AT_FEDEX_LOCATION",
            rateRequestType: [
                "ACCOUNT",
                "LIST"
            ],
            requestedPackageLineItems: [
                {
                    groupPackageCount: 1,
                    declaredValue: {
                        amount: "100.00",
                        currency: "BRL"
                    },
                    weight: {
                        units: "KG",
                        value: 1
                    }
                }
            ],
            packagingType: "YOUR_PACKAGING",
            customsClearanceDetail: {
                dutiesPayment: {
                    paymentType: "SENDER"
                },
                commodities: [
                    {
                        description: "Caixa preta",
                        weight: {
                            units: "KG",
                            value: 1
                        },
                        quantity: 1,
                        customsValue: {
                            amount: "100.00",
                            currency: "BRL"
                        },
                        unitPrice: {
                            amount: "100.00",
                            currency: "BRL"
                        },
                        quantityUnits: "PCS"
                    }
                ]
            }
        }
    },

    Normalize: function (quotation, data) {
        const currency = CurrencyConverter(Storage.getCurrency());

        data.origin.state = "";
        data.destination.state = "";

        console.log("O que esta sendo", data);
        let root = {};
        let requestedShipment = {
            // serviceType: "FEDEX_INTERNATIONAL_PRIORITY_EXPRESS",
            shipDateStamp: DateTimeNowSimple(),
            pickupType: "USE_SCHEDULED_PICKUP",
            rateRequestType: [
                "PREFERRED"
            ],
            totalPackageCount: 0,
            totalWeight: 0,
        };
        let shipper = {
            address: {
                streetLines: [],
                city: data.origin.city,
                stateOrProvinceCode: data.origin.state,
                postalCode: data.origin.zipCode,
                countryCode: data.origin.country,
                residential: data.origin.residential,
            }
        };
        let recipient = {
            address: {
                streetLines: [
                    data.destination.addressLine1,
                ],
                city: data.destination.city,
                stateOrProvinceCode: data.destination.state,
                postalCode: data.destination.zipCode,
                countryCode: data.destination.country,
                residential: data.destination.residential,
            }
        };

        if (data.origin.addressLine1) {
            shipper.address.streetLines.push(data.origin.addressLine1)
        }

        if (data.origin.addressLine2) {
            shipper.address.streetLines.push(data.origin.addressLine2)
        }

        if (data.origin.addressLine3) {
            shipper.address.streetLines.push(data.origin.addressLine3)
        }

        if (data.destination.addressLine1) {
            recipient.address.streetLines.push(data.destination.addressLine1)
        }

        if (data.destination.addressLine2) {
            recipient.address.streetLines.push(data.destination.addressLine2)
        }

        if (data.destination.addressLine3) {
            recipient.address.streetLines.push(data.destination.addressLine3)
        }

        let accountNumber = {
            value: "201965867"
        };

        let commodities = []
        let requestedPackageLineItems = []

        requestedShipment.totalPackageCount = data.boxes.length;
        requestedShipment.preferredCurrency = currency;
        let totalPrice = 0;
        for (let s in data.boxes) {
            requestedShipment.totalWeight += data.boxes[s].weight;
            totalPrice += data.boxes[s].price;
            const box = {
                groupPackageCount: 1,
                declaredValue: {
                    amount: `${data.boxes[s].price}`,
                    currency: currency
                },
                weight: {
                    units: "KG",
                    value: data.boxes[s].weight,
                },
                dimensions: {
                    length: parseInt(data.boxes[s].depth),
                    depth: parseInt(data.boxes[s].depth),
                    width: parseInt(data.boxes[s].width),
                    height: parseInt(data.boxes[s].height),
                    units: "CM"
                }
            };

            requestedPackageLineItems.push(box);

            // if (quotation.object == "not_doc") {
            for (let i in data.boxes[s].items) {
                const item = data.boxes[s].items[i];
                const commodity = {
                    harmonizedCode: item.hscode != null && item.hscode != undefined ? `${item.hscode.length < 10 ? `${item.hscode}0000` : item.hscode}` : "",
                    name: item.name,
                    description: item.description,
                    numberOfPieces: item.quantity,
                    countryOfManufacture: item.countryCode,
                    weight: {
                        units: "KG",
                        value: item.weight,
                    },
                    quantity: item.quantity,
                    customsValue: {
                        amount: `${item.unitValue * item.quantity}`,
                        currency: currency
                    },
                    unitPrice: {
                        amount: `${item.unitValue}`,
                        currency: currency
                    },
                    quantityUnits: "PCS"
                }
                commodities.push(commodity);
            }
            // }
        }

        requestedShipment.totalDeclaredValue = {
            amount: totalPrice,
            currency: currency
        }
        let customsClearanceDetail = {
            dutiesPayment: {
                // paymentType: quotation.tax == "sender" ? "SENDER" : "RECIPIENT",
                paymentType: "SENDER",
            },
            commodities,
        }

        if (quotation.object == "doc") {
            customsClearanceDetail.isDocumentOnly = true;
        }

        requestedShipment.shipper = shipper;
        requestedShipment.recipient = recipient;
        requestedShipment.customsClearanceDetail = customsClearanceDetail;
        requestedShipment.requestedPackageLineItems = requestedPackageLineItems;
        requestedShipment.edtRequestType = "ALL";


        root.accountNumber = accountNumber;
        root.requestedShipment = requestedShipment;


        if (quotation.object == "doc") {
            root.requestedShipment.packagingType = "FEDEX_ENVELOPE";
        } else {
            root.requestedShipment.packagingType = "YOUR_PACKAGING";
        }

        root.rateRequestControlParameters = {
            returnTransitTimes: true
        };
        return root;
    },

    Quotation: async function (data, response, error) {
        await BaseService(
            {
                method: "POST",
                url: `fedex/quotation`,
                data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    CheckAvailability: async function (data, response, error) {
        await BaseService(
            {
                method: "POST",
                url: `fedex/Pickup/CheckAvailability`,
                data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    PickupCreate: async function (data, response, error) {
        await BaseService(
            {
                method: "POST",
                url: `fedex/Pickup/Create`,
                data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    CancelPickup: async function (data, response, error) {
        await BaseService(
            {
                method: "PUT",
                url: `fedex/Pickup/Cancel`,
                data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Get: async function (trackingNumber, response, error) {
        await BaseService(
            {
                method: "POST",
                url: `fedex/Tracking/?trackingNumber=${trackingNumber}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },
}